export enum MensajeError {
  VALIDANDO_PAGO = 'Espera un momento. Estamos validando tu pago.',
  SERVICIO_NO_DISPONIBLE = 'Lo sentimos. Se ha presentado un error. Por favor inténtalo de nuevo.',
  MAXIMO_INTENTOS = 'Has superado el máximo de intentos para pagar el seguro. Te invitamos a comenzar de nuevo tu proceso de compra.',
  NO_SE_PUDO_CARGAR_EL_CONTENIDO = 'No se pudo cargar el contenido',
  TIEMPO_LIMITE_TRANSACCION = 'El tiempo para finalizar la transacción expiró, para realizar tu pago regresa al proceso de cotización.',
  PAGO_PENDIENTE = 'El pago de tu seguro está en proceso de aprobación. En tu correo electrónico recibirás el resultado; te recomendamos no repetir esta transacción hasta entonces.',
  SERVICIO_INDISPONIBLE = 'Algo no salió bien. Por favor intentalo de nuevo más tarde.',
  ERROR_CONSULTANDO_ESTADO_PAGO = 'Algo no salió bien. Por favor espera un momento y vuelve a intentarlo.',
}
